const TEAM = [
  {
    initials: "MB",
    name: "Monika",
    role: "Stylistka paznokci · właścicielka",
    specialty: "Manicure hybrydowy, tytanowy, autorskie zdobienia",
    bio: "Ponad 20 lat doświadczenia w stylizacji paznokci. Ciągle się kształci — najnowsze trendy 2026 poznaje na kursach w Polsce i za granicą.",
  },
  {
    initials: "AK",
    name: "Ania",
    role: "Podolog",
    specialty: "Klamry ortonyksyjne, brodawki wirusowe, terapia mykologiczna",
    bio: "Certyfikowana podolog. Prowadzi z pełną empatią pacjentów z bólem stóp, cukrzycą oraz seniorów.",
  },
  {
    initials: "PW",
    name: "Paulina",
    role: "Kosmetolog",
    specialty: "Mezoterapia mikroigłowa, Kobido, peelingi chemiczne",
    bio: "Kosmetolog z zamiłowaniem do skin longevity. Pracuje na najnowszych markach zabiegowych: DIVES Med, egzosomy, PDRN.",
  },
];

export default function Team() {
  return (
    <section
      className="max-w-7xl mx-auto px-6 md:px-10 py-24"
      data-testid="team-section"
      aria-label="Zespół BEAUTIX Katowice"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
        <div className="lg:col-span-7">
          <p className="eyebrow mb-4">Zespół</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Poznaj kobiety, które
            <br />
            <span className="italic text-[var(--beautix-pink)]">tworzą</span> BEAUTIX.
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-base text-[var(--beautix-muted)] leading-relaxed font-light">
            Trzy specjalizacje, trzy kobiety, jedna filozofia — czystość,
            wiedza i indywidualne podejście do każdej klientki.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TEAM.map((m) => (
          <article
            key={m.initials}
            data-testid={`team-${m.initials}`}
            className="p-8 md:p-10 border border-[var(--beautix-line)] bg-white flex flex-col gap-5 group hover:border-[var(--beautix-pink)] transition-colors"
          >
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[var(--beautix-blush)] to-[var(--beautix-blush-2)] flex items-center justify-center font-serif-display text-2xl text-[var(--beautix-pink-dark)]">
              {m.initials}
            </div>
            <div>
              <h3 className="font-serif-display text-3xl leading-tight">
                {m.name}
              </h3>
              <p className="text-xs tracking-[0.24em] uppercase text-[var(--beautix-muted)] mt-2">
                {m.role}
              </p>
            </div>
            <p className="text-sm text-[var(--beautix-pink)] font-medium">
              {m.specialty}
            </p>
            <p className="text-sm text-[var(--beautix-muted)] leading-relaxed font-light">
              {m.bio}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
